'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isContactAssociationMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isContactAssociationMessage = exports.isContactAssociationMessage = (0, _isType.isType)(_messageTypes.CONTACT_ASSOCIATION);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isContactAssociationMessage.js
// module id = 806
// module chunks = 2 3